import styled from '@emotion/styled';

/* ===== Outer wrapper — sets the scroll boundary ===== */
export const ScrollWrapper = styled.div<{ $maxHeight?: string | undefined }>`
  position: relative;
  ${({ $maxHeight }) => $maxHeight ? `max-height: ${$maxHeight};` : ''}
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

/* ===== Scrollable inner container ===== */
export const ScrollContainer = styled.div<{ $native: boolean }>`
  height: 100%;
  max-height: inherit;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${({ $native }) =>
    $native
      ? `
    /* Hide native scrollbar on Capacitor — we draw our own */
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
    /* Leave room for the custom thumb */
    padding-right: 10px;
  `
      : `
    /* Web / desktop: thin styled scrollbar */
    padding-right: 4px;
    scrollbar-width: thin;
    scrollbar-color: #3a3c44 transparent;

    &::-webkit-scrollbar { width: 4px; }
    &::-webkit-scrollbar-track { background: transparent; }
    &::-webkit-scrollbar-thumb {
      background: #3a3c44;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #4a4c54;
    }
  `}
`;

/* ===== Custom scrollbar track (native only) ===== */
export const Track = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 4px;
  border-radius: 4px;
  pointer-events: none;
`;

/* ===== Custom scrollbar thumb (native only) ===== */
export const Thumb = styled.div<{ $height: number; $top: number; $visible: boolean }>`
  position: absolute;
  right: 0;
  width: 4px;
  border-radius: 4px;
  background: #3a3c44;
  pointer-events: none;
  transition: opacity 0.25s ease;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  top: ${({ $top }) => $top}px;
  height: ${({ $height }) => $height}px;
  min-height: 20px;
`;
